import { UploadOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Space, Upload } from "antd";
import { useTranslation } from "react-i18next";
import { normFile } from "utils/";

export default function AdminBudgetImport({ form, loading, onFinish, show, onCancel }) {
    const { t } = useTranslation()

    return (
        <Modal
            open={show}
            onCancel={onCancel}
            title={t('import') + ' ' + t('budget')}
            footer=''
            width={600}
        >
            <Form form={form} onFinish={onFinish} layout='vertical'>
                <Form.Item
                    name="upload"
                    rules={[{ required: true }]}
                    label="File Excel"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                >
                    <Upload
                        name="file"
                        listType="picture"
                        accept=".xlsx"
                        maxCount={1}
                    >
                        <Button icon={<UploadOutlined />}>{t('upload')}</Button>
                    </Upload>
                </Form.Item>
                <Form.Item>
                    <Space>
                        <Button loading={loading} htmlType="submit" type='primary' size='large'>
                            {t('import')}
                        </Button>
                        <Button loading={loading} size='large' onClick={onCancel}>
                            {t('cancel')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
}
